import { useRef, useState } from "react";
import { IoIosClose } from "react-icons/io";
import "./MarketingCampaignEditForm.scss"; // Asumo que usas los mismos estilos base
import { updateMarketingCampaign } from "../../api/marketingCampaigns.api";
import EmailEditor from "react-email-editor";

const MarketingCampaignEditForm = ({
  setOpenEditCampaignForm,
  campaigns,
  setCampaigns,
  campaign,
  index,
}) => {
  const emailEditorRef = useRef(null);

  // 1. Inicializamos el título con el valor existente
  const [title, setTitle] = useState(campaign.title || "");
  const [titleError, setTitleError] = useState(false);

  // 2. Cargamos el diseño guardado en cuanto el editor esté listo
  const onLoad = () => {
    if (campaign.design && emailEditorRef.current) {
      emailEditorRef.current.editor.loadDesign(campaign.design);
    }
  };

  const handleUpdateDesign = async (e) => {
    e.preventDefault();

    if (title.trim() === "") {
      setTitleError(true);
      return;
    }

    // 3. Extraemos el HTML y el JSON actualizados
    emailEditorRef.current.editor.exportHtml(async (data) => {
      const { design, html } = data;

      // Enviamos el payload limpio (sin FormData)
      const payload = {
        title: title,
        htmlBody: html,
        design: design,
      };

      try {
        const uploadCampaign = await updateMarketingCampaign(
          payload,
          campaign._id,
        );

        // 4. Actualizamos la tarjeta en la vista principal
        if (Object.keys(uploadCampaign).includes("_id")) {
          // toSpliced no muta el array original, devuelve uno nuevo
          const newCampaigns = campaigns.toSpliced(index, 1, uploadCampaign);
          setCampaigns(newCampaigns);
          setOpenEditCampaignForm(false);
        }
      } catch (error) {
        console.error("Error al editar la campaña:", error);
        alert("Hubo un error al actualizar la plantilla.");
      }
    });
  };

  return (
    <div
      className="MarketingCampaignEditForm"
      style={{
        backgroundColor: "#fff",

        zIndex: 2,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="MarketingCampaignEditForm__title"
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "20px",
        }}
      >
        <h1>Editar Plantilla de Campaña</h1>
        <IoIosClose
          className="cursor"
          size={30}
          onClick={() => setOpenEditCampaignForm(false)}
        />
      </div>

      <div style={{ padding: "0 20px", marginBottom: "15px", width: "100%" }}>
        <label
          htmlFor="customTitle"
          style={{ fontWeight: "bold", marginBottom: "5px", display: "block" }}
        >
          Nombre de la plantilla
        </label>
        <input
          id="customTitle"
          type="text"
          className="yearInput"
          placeholder="Ej: Campaña de Navidad..."
          value={title}
          onChange={(e) => {
            setTitle(e.target.value);
            setTitleError(false);
          }}
          style={{
            width: "50%",
            padding: "10px",
            borderRadius: "4px",
            border: titleError ? "1px solid red" : "1px solid #ccc",
          }}
        />
        {titleError && (
          <p
            className="error"
            style={{ color: "red", fontSize: "12px", marginTop: "5px" }}
          >
            *Por favor, dale un nombre a tu plantilla.
          </p>
        )}
      </div>

      <div style={{ width: "100%", height: "70vh" }}>
        <EmailEditor
          ref={emailEditorRef}
          height="60vh"
          onLoad={onLoad} // 👈 Inyectamos el diseño preexistente aquí
          style={{ width: "100%", height: "500px" }}
        />
      </div>

      <div
        style={{
          marginTop: "15px",
          padding: "0 20px",
          display: "flex",
          gap: "10px",
        }}
      >
        <button
          type="button"
          className="subHeader__btn"
          onClick={handleUpdateDesign}
        >
          Guardar Cambios
        </button>
        <button
          type="button"
          className="buttonFormCancelCampaign"
          onClick={() => setOpenEditCampaignForm(false)}
        >
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default MarketingCampaignEditForm;
